import {authorizedRequest} from '../../common/request';
import {discActionTypes} from './disc-action-types';
import {DISC_MEDIA_TYPE} from "./disc-constants"
import {cartActionTypes} from "../../cart/actions/cart-action-types";
import {albumCreated, albumCreationFailed} from "../../album-view/actions/album-actions"

export const clearDiscPackages = () => {
    return {
        type: discActionTypes.CLEAR_DISC_PACKAGES
    }
}
export const requestDiscPackages = (dispatch, offset = 0, max = 25) => {
    return requestDiscPackagesRoot(dispatch, offset, max);
};

export const requestDiscPackagesForSelect = (dispatch, offset = 0, max = 50) => {
    return requestDiscPackagesRoot(dispatch, offset, max, false, null, null, null, true);
};

export const requestFinalizedDiscs = (dispatch, offset = 0, max = 50) => {
    return requestDiscPackagesRoot(dispatch, max, offset);
};


export const rotateDiscItem = (dispatch, discId, id, rotation)=> {
	authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/rotate/pcdsp/${id}/${rotation}`)
		.then(() => dispatch(rotateItemSuccess(discId, id, rotation)))
		.catch(error => dispatch(rotateItemError(error)));

	return {
		type: discActionTypes.DISC_ITEM_ROTATE_REQUEST
	};
};

const rotateItemSuccess = (discId, id, rotation) => {
	return {
		type: discActionTypes.DISC_ITEM_ROTATE_SUCCESS,
        id,
        discId,
        rotation
	};
};

const rotateItemError = error => {
	return {
		type: discActionTypes.DISC_ITEM_ROTATE_ERROR,
		error
	};
};

export const deleteDiscPackage = (dispatch, discType, discId) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/`;
    uri += discType === 'PhotoCdPackage' || discType === "dvd_photo_data" ? `pcdpkg` : 'dvdpkg';

    uri += "/" + discId;
    authorizedRequest(uri, null, 'DELETE',false,false)
        .then(
            dispatch({
                type: discActionTypes.DELETE_DISC_SUCCESS,
                discId: discId
            })
        )
        .catch(error => {
            dispatch({
                type: discActionTypes.DELETE_DISC_FAILED,
                errorMessage: error,
                discId: discId
            })
        });
}

export const deleteDiscDescriptor = (dispatch, discDescriptorId) => {
    dispatch({
        type: discActionTypes.DISC_WIZARD_ROLLBACK_SAVED
    });
    //It might take a while to delete the disc.  Dispatching now so the UI
    //is more responsive
    dispatch({
        type: discActionTypes.DELETE_DISC_DISCRIPTOR_SUCCESS,
        discId: discDescriptorId,
        discDescriptorId: discDescriptorId
    })
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/discdsc`;
    uri += "/" + discDescriptorId;
    return new Promise((resolve, reject) => {
        authorizedRequest(uri, null, 'DELETE')
            .then(() => {
                    dispatch({
                        type: discActionTypes.DELETE_DISC_DISCRIPTOR_SUCCESS,
                        discId: discDescriptorId,
                        discDescriptorId: discDescriptorId
                    })
                    resolve()
                }
            )
            .catch(error => {
                dispatch({
                    type: discActionTypes.DELETE_DISC_DISCRIPTOR_FAILED,
                    errorMessage: error,
                    discDescriptorId: discDescriptorId
                })
                reject()
            });
    });

}

export const createDiscRequest = (dispatch, title, subtitle, spineTitle, discType, id = null) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/`;

    uri += discType === 'dvd_photo_data' ? 'pcdpkg' : 'dvdpkg';
    const packageTitleObject = {
        displayName: title,
        caseTitle: title,
        caseSubtitle: subtitle,
        caseSpineTitle: spineTitle,
        mediaType: discType === "bluray_video" ? DISC_MEDIA_TYPE.BLURAY_MEDIA_TYPE : DISC_MEDIA_TYPE.DVD_MEDIA_TYPE
    };
    if (id !== null) {
        uri += "/" + id
    }
    uri += "?format=deep"

    authorizedRequest(uri, packageTitleObject, id === null ? "POST" : "PUT")
        .then(data => {
            dispatch(createDiscSuccess(data))
        })
        .catch(error => dispatch(createDiscFailed(error)));

    return {
        type: discActionTypes.CREATE_DISC_REQUEST
    };
};
export const requestDiscsForDescriptor = (dispatch,
                                          discDescriptorId,
                                          offset = 0,
                                          max = 100,
                                          sort = null,
                                          order = null,
                                          format = 'deep',
                                          callback) => {
    authorizedRequest(
        `${process.env.REACT_APP_WEB_API_URI}/sec/v1/discdsc/${discDescriptorId}/discpkgs${buildDiscQueryString(
            offset,
            max,
            null,
            sort,
            order,
            format
        )}`,null,"GET")
        .then(discData => {
            dispatch(discsReceived(discData,false));
            if(callback != null && typeof(callback) == "function"){
                callback(discData);
            }
        })
        .catch(error => {
            dispatch(discsError(error));
            if(callback != null && typeof(callback) == "function"){
                callback(error);
            }
        });
    return {
        type: discActionTypes.CLEAR_DISC_PACKAGES
    };
}
    
    

//TODO: May change the form of this.
const requestDiscPackagesRoot = (dispatch,
                                 offset = 0,
                                 max,
                                 finalized = null,
                                 sort = null,
                                 order = null,
                                 format = 'deep',
                                 forSelect = false) => {
    authorizedRequest(
        `${process.env.REACT_APP_WEB_API_URI}/sec/v1/discpkg${buildDiscQueryString(
            offset,
            max,
            finalized,
            sort,
            order,
            format
        )}`
    )
        .then(discData => {
            dispatch(discsReceived(discData, forSelect,offset))
            console.log("requestDiscPackagesRoot.  offset: "+offset +" resultLength: " + discData.results.length+" count:" + discData.count)
            if((offset + discData.results.length) < discData.count ){

                setTimeout(()=>dispatch(requestDiscPackagesRoot (dispatch, offset+max,max,finalized,sort,order,format,forSelect)),100);
            }
        })
        .catch(error => dispatch(discsError(error)));

    return {
        type: discActionTypes.DISCS_REQUESTED
    };
};
export const requestDiscWizard = (dispatch, status) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/discdsc`
    if(status != null){
        uri += "/status/"+status
    }
    authorizedRequest(
        uri,null,"GET"
    )
        .then(discData => dispatch(
            {
                type: discActionTypes.DISC_WIZARD_DATA_RECEIVED,
                data: discData
            }
        ))
        .catch(error => dispatch(discsError(error)));

    return {
        type: discActionTypes.DISC_WIZARD_DATA_REQUESTED
    };
}

const createDiscSuccess = discData => {
    return {
        type: discActionTypes.CREATE_DISC_SUCCESS,
        element: discData
    };
};

const createDiscFailed = error => {
    return {
        type: discActionTypes.CREATE_DISC_FAILED,
        error: error
    };
};

const discsReceived = (discData, forSelect) => {
    return {
        type: forSelect ? discActionTypes.DISCS_RECEIVED_FOR_SELECT : discActionTypes.DISCS_RECEIVED,
        discData: discData,
        discs: discData.results,
        offset: discData.offset + discData.results.length,
        offsetStart: discData.offset,
        count: discData.count,
        ids: typeof(discData.ids) === "undefined"?[]:discData.ids,
        max: discData.max,
        isComplete: discData.offset + discData.results.length === discData.count,

    };
};

const discsError = error => {
    return {
        type: discActionTypes.DISCS_REQUEST_FAILED,
        error: error
    };
};

const buildDiscQueryString = (offset, max, finalized, sort, order, format) => {
    let returnString = ""
    if(finalized != null){
        returnString += "/status/" + (finalized ? 'finalized' : 'unfinalized')
    }
    returnString += '?';

    returnString += `max=${max}`;
    returnString += `&offset=${offset}`;
    if (sort) returnString += `&sort=${sort}`;
    if (order) returnString += `&order=${order}`;
    if (format) returnString += `&format=${format}`;
    return returnString;
};

export const finalizeDisc = (dispatch, discId, discType) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/add/`;

    uri += discType === 'PhotoCdPackage' || discType === "dvd_photo_data" ? 'pcdpkg' : 'dvdpkg';

    if (discId !== null) {
        uri += "/" + discId
    }
    uri += "?format=deep"

    authorizedRequest(uri, null, "POST")
        .then(data => {
            dispatch({
                type: discActionTypes.FINALIZE_DISC_SUCCESS,
                element: {id: discId, discType: discType, cart: data}
            })
            dispatch({
                type: cartActionTypes.CART_RECEIVED,
                element: data
            })
        })
        .catch(error => dispatch({
            type: discActionTypes.FINALIZE_DISC_FAILED,
            element: error
        }));

    return {
        type: discActionTypes.FINALIZE_DISC_REQUEST,
        element: {id: discId, discType: discType}
    };
}
export const addUnfinalizedToCart = (dispatch) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/add/unfinalizedDiscs`;
    uri += "?format=deep"

    authorizedRequest(uri, null, "PUT")
        .then(data => {
            if(data.errorMessage){
                dispatch({
                    type: cartActionTypes.FINALIZE_DISC_FAILED,
                    element: data
                })
            }else {
                dispatch({
                    type: cartActionTypes.CART_RECEIVED,
                    element: data
                })
            }
        })
        .catch(error => dispatch({
            type: discActionTypes.FINALIZE_DISC_FAILED,
            element: error
        }));

    return {
        type: discActionTypes.FINALIZE_DISC_REQUEST,
        element: {id: -1, discType: "unfinalized"}
    };
}
export const addFinalizedToCart = (dispatch) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/add/finalizedDiscs`;
    uri += "?format=deep"

    authorizedRequest(uri, null, "PUT")
        .then(data => {
            if(data.errorMessage){
                dispatch({
                    type: cartActionTypes.FINALIZE_DISC_FAILED,
                    element: data
                })
            }else {
                dispatch({
                    type: cartActionTypes.CART_RECEIVED,
                    element: data
                })
            }
        })
        .catch(error => dispatch({
            type: discActionTypes.FINALIZE_DISC_FAILED,
            element: error
        }));

    return {
        type: discActionTypes.FINALIZE_DISC_REQUEST,
        element: {id: -1, discType: "finalized"}
    };
}
export const addDiscDescriptorToCart = (dispatch,id,callback) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/cart/add/discdsc/${id}`;
    uri += "?format=deep"

    authorizedRequest(uri, null, "PUT")
        .then(data => {
            if(data.errorMessage){
                dispatch({
                    type: cartActionTypes.FINALIZE_DISC_FAILED,
                    element: data
                })
                if(callback != null){
                    callback(data);
                }
            }else {
                dispatch({
                    type: cartActionTypes.CART_RECEIVED,
                    element: data
                })
                if(callback != null){
                    callback(data);
                }
            }
        })
        .catch(error => {
            dispatch({
                type: discActionTypes.FINALIZE_DISC_FAILED,
                element: error
            })
            if (callback != null) {
                callback(data);
            }

        });

    return {
        type: discActionTypes.FINALIZE_DISC_REQUEST,
        element: {id: -1, discType: "unfinalized"}
    };
}
export const updateChapterProps = (dispatch,discItemId,discPackageType,data) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/`;
    uri += discPackageType === 'PhotoCdPackage' ? 'pcdsp' : 'dvdchap';
    uri += "/" + discItemId
    authorizedRequest(uri, data, "PUT")
        .then(data => {
            if (data.errorMessage) {
                dispatch({
                    type: discActionTypes.UPDATE_CHAPTER_FAILED,
                    element: data
                })
            } else {
                dispatch({
                    type: discActionTypes.UPDATE_CHAPTER_SUCCESS,
                    element: {
                        value: data,
                        discItemId: discItemId,
                        discPackageType: discPackageType
                    }
                })
            }
        })
        .catch(error => dispatch({
                type: discActionTypes.UPDATE_CHAPTER_FAILED,
                element: error
            })
        );

    return {
        type: discActionTypes.UPDATE_CHAPTER_REQUESTED,
        element: {value: data, discItemId: discItemId, discPackageType: discPackageType}
    };
}
export const addItemsToDisc = (dispatch, itemArray, itemType, discId, discPackageType,callback) =>
{
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/`;
    uri += discPackageType === 'PhotoCdPackage' ? 'pcdpkg' : 'dvdpkg';
    uri += "/" + discId
    uri += "/add/" + itemType

    authorizedRequest(uri, itemArray, "PUT")
        .then(data => {
            if (data.errorMessage) {
                if(callback != null){
                    callback({status:"FAILED",errorMessage:data.errorMessage})
                }
                dispatch({
                    type: discActionTypes.ADD_TO_DISC_FAILED,
                    element: data
                })
            } else {
                if(callback != null){
                    callback({status:"OK",data:data})
                }
                dispatch({
                    type: discActionTypes.ADD_TO_DISC_SUCCESS,
                    element: {
                        itemIds: itemArray,
                        itemType: itemType,
                        discId: discId,
                        discPackageType: discPackageType,
                        chapters: data
                    }
                })
            }
        })
        .catch(error => {
                if(callback != null){
                    callback({status:"FAILED",errorMessage: error})
                }
                dispatch({
                    type: discActionTypes.ADD_TO_DISC_FAILED,
                    element: error
                })
            }

        );

    return {
        type: discActionTypes.ADD_TO_DISC_REQUEST,
        element: {itemIds: itemArray, itemType: itemType, discId: discId, discPackageType: discPackageType}
    };
}
export const addItemToDisc = (dispatch, itemId, itemType, discId, discPackageType, callback) =>
{
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/`;
    uri += discPackageType === 'PhotoCdPackage' ? 'pcdpkg' : 'dvdpkg';
    uri += "/" + discId
    uri += "/add/" + itemType + "/" + itemId

    authorizedRequest(uri, null, "PUT")
        .then(data => {
            if (data.errorMessage) {
                if(callback != null){
                    setTimeout(()=>callback({status:"FAILED",errorMessage:data.errorMessage}))
                }
                dispatch({
                    type: discActionTypes.ADD_TO_DISC_FAILED,
                    element: data
                })
            } else {
                if(callback != null){
                    setTimeout(()=>callback({status:"OK",data:data}));
                }
                dispatch({
                    type: discActionTypes.ADD_TO_DISC_SUCCESS,
                    element: {
                        itemId: itemId,
                        itemType: itemType,
                        discId: discId,
                        discPackageType: discPackageType,
                        chapters: data
                    }
                })
            }
        })
        .catch(error => {
            error.json().then(errorObj => {
                if (callback != null) {
                    setTimeout(() => callback({status: "FAILED", errorMessage: errorObj.errorMessage}));
                }
                dispatch({
                    type: discActionTypes.ADD_TO_DISC_FAILED,
                    element: errorObj
                })
            })
        }

        );

    return {
        type: discActionTypes.ADD_TO_DISC_REQUEST,
        element: {itemId: itemId, itemType: itemType, discId: discId, discPackageType: discPackageType}
    };
}
export const addDiscToDisc = (dispatch, toDiscId, fromDiscId, discPackageType, callback) =>
{
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/`;
    uri += discPackageType === 'PhotoCdPackage' ? 'pcdpkg' : 'dvdpkg';
    uri += "/" + toDiscId
    uri += "/add/discpkg/" + fromDiscId
    authorizedRequest(uri, null, "PUT")
        .then(data => {
            if (data.errorMessage) {
                if(callback != null){
                    setTimeout(()=>callback({status:"FAILED",errorMessage:data.errorMessage}))
                }
                dispatch({
                    type: discActionTypes.ADD_TO_DISC_FAILED,
                    element: data
                })
            } else {
                if(callback != null){
                    setTimeout(()=>callback({status:"OK",data:data}));
                }
                dispatch({
                    type: discActionTypes.ADD_DISC_TO_DISC_SUCCESS,
                    element: {
                        itemId: fromDiscId,
                        itemType: "discpkg",
                        discId: toDiscId,
                        discPackageType: discPackageType,
                        disc: data
                    }
                })
            }
        })
        .catch(error => {
                if (error.json) {
                    error.json().then(errorObj => {
                        if (callback != null) {
                            setTimeout(() => callback({status: "FAILED", errorMessage: errorObj.errorMessage}));
                        }
                        dispatch({
                            type: discActionTypes.ADD_TO_DISC_FAILED,
                            element: errorObj
                        })
                    })
                }else{
                    if (callback != null) {
                        setTimeout(() => callback({status: "FAILED", errorMessage: error}));
                    }
                }
            }

        );

    return {
        type: discActionTypes.ADD_TO_DISC_REQUEST,
        element: {itemId: fromDiscId, itemType: "discPkg", discId: toDiscId, discPackageType: discPackageType}
    };
}

export const fetchDiscWithoutType = (discId) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/discpkg/${discId}?type=UNKNOWN&format=deep`;
    return authorizedRequest(uri,null,"GET");
}

export const fetchDiscDetails = (dispatch, discId, discPackageType,offset=0,max=100) =>
{
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/`;
    if(discPackageType === "PhotoCdPackage"){
        uri += "pcdpkg/" + discId + "/pcdsps"
    }else{
        uri += "dvdpkg/" + discId + "/dvdchaps"
    }
    uri +=  "?max="+max+"&offset="+offset+"&format=deep"

    authorizedRequest(uri, null, "GET")
        .then(data => {
            if (data.errorMessage) {
                dispatch({
                    type: discActionTypes.FETCH_DISC_FAILED,
                    element: data
                })
            } else {
                dispatch({
                    type: discActionTypes.FETCH_DISC_SUCCESS,
                    discId: parseInt(discId,10),
                    discPackageType: discPackageType,
                    offset: data.offset,
                    max: data.max,
                    offsetStart: data.offset,
                    count: data.count,
                    isComplete: data.offset + data.results.length === data.count,
                    chapters: data.results,
                    ids: typeof(data.ids) === "undefined"?[]:data.ids
                })
            }
        })
        .catch(error => dispatch({
                type: discActionTypes.FETCH_DISC_FAILED,
                element: error
            })
        );

    return {
        type: discActionTypes.FETCH_DISC_REQUEST,
        element: { discId: discId, discPackageType: discPackageType}
    };
}
export const clearDiscItems = () => {
    return{
        type: discActionTypes.CLEAR_DISC_ITEMS
    }
}
export const clearSelectedDiscItems = () => {
    return {
        type: discActionTypes.CLEAR_SELECTED_DISC_ITEMS
    }
}
export const selectDiscItem = (discItemId) => {
    return {
        type: discActionTypes.SELECT_DISC_ITEM,
        element: {id: discItemId}
    }
}
export const deSelectDiscItem = (discItemId) => {
    return {
        type: discActionTypes.DESELECT_DISC_ITEM,
        element: {id: discItemId}
    }
}
export const enableDiscItemSelectionMode = () => {
    return {
        type: discActionTypes.ENABLE_DISC_ITEM_SELECTION_MODE
    }
}
export const disableDiscItemSelectionMode = () => {
    return {
        type: discActionTypes.DISABLE_DISC_ITEM_SELECTION_MODE
    }
}
export const deleteSelectedDiscItems = (dispatch,selectedDiscDetail) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/`;
    if(selectedDiscDetail.discPackageType === "PhotoCdPackage"){
        uri += "pcdsp"
    }else{
        uri += "dvdchap"
    }
    const selectedIds = selectedDiscDetail.chapters.filter(item => (item.selected ===true)).map(item=>item.id)
    authorizedRequest(uri, selectedIds, "DELETE")
        .then(
            dispatch({
                    type: discActionTypes.DELETE_SELECTED_ITEMS_SUCCESS,
                    element: {
                        ids: selectedIds
                    }
                })

        )
        .catch(error => dispatch({
                type: discActionTypes.DELETE_SELECTED_ITEMS_FAILED,
                element: error
            })
        );
    return {
        type: discActionTypes.DELETE_SELECTED_ITEMS_REQUESTED
    }
}

export const deleteSelectedDiscItemsMediaPlayer = (dispatch,discPackageType, itemId) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/`;
    if(discPackageType === "PhotoCdPackage"){
        uri += "pcdsp"
    }else{
        uri += "dvdchap"
    }
   const selectedIds = [itemId];
    authorizedRequest(uri, selectedIds, "DELETE")
        .then(
            dispatch({
                    type: discActionTypes.DELETE_SELECTED_ITEMS_SUCCESS,
                    element: {
                        ids: selectedIds
                    }
                })

        )
        .catch(error => dispatch({
                type: discActionTypes.DELETE_SELECTED_ITEMS_FAILED,
                element: error
            })
        );
    return {
        type: discActionTypes.DELETE_SELECTED_ITEMS_REQUESTED
    }
}
export const enableDiscItemArrangeMode = () => {
    return {
        type: discActionTypes.ENABLE_DISC_ITEM_ARRANGE_MODE
    }
}
export const disableDiscItemArrangeMode = () => {
    return {
        type: discActionTypes.DISABLE_DISC_ITEM_ARRANGE_MODE
    }
}
export const moveDiscItemAfter = (itemToMove, itemToMoveAfter) => {
    return {
        type: discActionTypes.MOVE_DISC_ITEM_AFTER,
        element: {discItemId: itemToMove, moveAfterItemId: itemToMoveAfter}
    }
}
export const saveArrangedDiscItems = (dispatch, request, discPackageType, onCompletedCallback) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/`;
    if(discPackageType === "PhotoCdPackage"){
        uri += "pcdsp"
    }else{
        uri += "dvdchap"
    }
    uri += "/displayorder"
    authorizedRequest(uri, request, "POST")
        .then((data)=>{
                if(onCompletedCallback) {
                    onCompletedCallback();
                }
                dispatch({
                    type: discActionTypes.SAVE_DISC_ARRANGEMENT_SUCCESS,
                    element:request
                })

            }
        )
        .catch(error => {
            alert(JSON.stringify(error));
            dispatch({
                    type: discActionTypes.SAVE_DISC_ARRANGEMENT_FAILED,
                    element: error
                })
            }
        );

    return {
        type: discActionTypes.SAVE_DISC_ARRANGEMENT
    }
}
export const setDiscWizardValue = (newVal) =>{
    return {
        type: discActionTypes.DISC_WIZARD_SET,
        data: newVal
    }
}
export const setRollbackPoint = (albumId) => {
    return {
        type: discActionTypes.DISC_WIZARD_SET_ROLLBACK_POINT,
        albumId: albumId
    }
}
export const rollbackAlbum = (albumId) => {
    return {
        type: discActionTypes.DISC_WIZARD_ROLLBACK,
        albumId: albumId
    }
}
export const selectMediaForDisc = (albumId,displayOrder,albumItemId,albumItemDisplayOrder,toggleMode) => {
    return {
        type: discActionTypes.DISC_WIZARD_SELECT_MEDIA,
        albumId: albumId,
        displayOrder: displayOrder,
        albumItemId: albumItemId,
        albumItemDisplayOrder: albumItemDisplayOrder,
        toggleMode: toggleMode
    }
}
export const saveDiscWizard = (dispatch, discWizard,callback) => {
    let uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/selection`;

    const request = []
    for(let i=0;i<discWizard.selectedMedia.length;i++){
        if(discWizard.selectedMedia[i].items.length === 0){
            request.push({"imemops.CustomCollection":[discWizard.selectedMedia[i].albumId]})
        }else{
            let itemIds = discWizard.selectedMedia[i].items.map(item=>item.id)
            request.push({"imemops.CustomCollectionElement":itemIds})
        }
    }

    authorizedRequest(uri, request, "POST")
        .then((data)=> {
                let discUri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/discdsc`;

                const req = {
                    selectionUuid: data.uuid,
                    discType: (discWizard.discPackageType === "dvd_photo_data" ? "PHOTO" : "VIDEO"),
                    mediaType: (discWizard.discPackageType === "bluray_video" ? "BD" : "DVD"),
                    albumPerDisc: (discWizard.albumsPerDisc === "one")

                }
                authorizedRequest(discUri, req, "POST")
                    .then((data) => {
                        dispatch({
                            type: discActionTypes.DISC_WIZARD_SAVE_SUCCESS,
                            element: request
                        })
                        if(callback){
                            callback({
                                success: true,
                                result: data
                            })
                        }

                    }).catch(error => {
                    if(callback){
                        callback({
                            success: false,
                            error: error
                        })
                    }
                    dispatch({
                        type: discActionTypes.DISC_WIZARD_SAVE_FAILED,
                        element: error
                    })
                })
            }
        )
        .catch(error => {
                alert(JSON.stringify(error));
                dispatch({
                    type: discActionTypes.DISC_WIZARD_SAVE_FAILED,
                    element: error
                })
            }
        );

    return {
        type: discActionTypes.DISC_WIZARD_SAVE_START
    }
}
export const getDiscInArrayById = (theArray, id) => {
    for(let i=0;i<theArray.length;i++){
        if(theArray[i].id === id){
            return theArray[i];
        }
    }
    return null;
}
export const recordScrollPosition = (scrollPosition) =>{
    return {
        type: discActionTypes.DISC_SCROLL,
        scrollPosition: scrollPosition
    }
}
export const recordDiscItemScrollPosition = (scrollPosition) =>{
    return {
        type: discActionTypes.DISC_ITEM_SCROLL,
        scrollPosition: scrollPosition
    }
}
export const addDiscToAlbum = (dispatch, discPackageType, discPackageId, albumId) => {
    authorizedRequest(
        `${process.env.REACT_APP_WEB_API_URI}/sec/v1/ccs/${albumId}/add/disc/${discPackageType}/${discPackageId}?format=deep`,
        null,
        'PUT'
    )
        .then(album => {
            if(album.errorMessage){
                alert("Failed to save disc to album.  Please contact customer support with this error: " + album.errorMessage);
            }else {
                dispatch(albumCreated(album))
            }
        })
        .catch(error => {
            dispatch(albumCreationFailed(error))
        });

}


// WEBPACK FOOTER //
// ./src/disc/actions/disc-actions.js